module.exports = __webpack_public_path__ + "static/logo-light-mobil-11866ded5ddc3111bbbaee12e8796020.png";